import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "@mui/material";
import { NavBar } from "../../../../components/NavBar/NavBar";
import { Wrapper } from "../../../../components/Wrapper/Wrapper";
import "./AircraftConfiguration.css";
import { useContext, useEffect, useRef, useState } from "react";
import {
  TypeSeriesConfigurationProvider,
  TypeSeriesConfigurationContext,
} from "../../contexts/TypeSeriesConfigurationContext";

import Filters from "../../../../components/Filters/Filters";
import TypeSeriesList from "./TypeSeriesList";
import { PermissionsProvider } from "../../../../contexts/PermissionsContext";
import { DropdownsProvider } from "../../../../contexts/DropdownsContext";
import { usePermissions } from "../../../../hooks/usePermissions";
import { useDispatch } from "react-redux";
import {
  addTab,
  clearActiveTab,
} from "../../../../redux/features/TabsManager/tabSlice";
import { FiltersManager } from "../../../../components/FiltersManager/FiltersManager";
import { SortingProvider } from "../../../../contexts/SortingContext";
import { SortingButton } from "../../../../components/Sorting/SortingButton";

const SearchBarContainer = () => {
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");
  const { onSearch } = useContext(TypeSeriesConfigurationContext);

  const didMount = useRef(false);
  const handleChange = (event) => {
    setInputValue(event.target.value);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 500); // 500ms delay

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true; // Evita la primera ejecución
      return;
    }
    onSearch(debouncedValue);
  }, [debouncedValue]);
  return <input placeholder="Search" onChange={handleChange} />;
};

const AddButtonContainer = () => {
  const { addType } = useContext(TypeSeriesConfigurationContext);
  const { hasPermission } = usePermissions();
  return (
    hasPermission("create") && (
      <button className="filled iconTextButton" onClick={addType}>
        <span className="pluse-icon">+</span> <span>Type/Series</span>
      </button>
    )
  );
};

const FilterContainer = ({ filtersOpen, setFiltersOpen }) => {
  const { onFilterForceChange } = useContext(TypeSeriesConfigurationContext);

  const doNothing = () => {};

  return (
    <Filters
      extOpen={filtersOpen}
      openChange={(value) => setFiltersOpen(value)}
      onApplyFilters={doNothing}
      hideToggle
    />
  );
};

export const AircraftConfiguration = () => {
  const [filters, setFilters] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
    const location = useLocation();
  const { dataFromManualSearch } = location.state || {};
  const clearTabsAndNavigate = (path) => {
    dispatch(clearActiveTab());
    navigate(path);
  };



  function generateUUID() {
    return crypto.randomUUID();
  }
  useEffect(() => {
    dispatch(
      addTab({
        icon: "icon-aircraft",
        color: "#7E38C4",
        path: "/configuration/aircraft",
        title: "Aircraft",
        isPinned: false,
        componentKey: "AircraftConfiguration",
        id: 14,
        date: generateUUID(),
        isModule: false,
      })
    );
  }, []);
  const dataBreadCrumbs = [
    <Link
      key={1}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => clearTabsAndNavigate("/secure/customdashboard")}
    >
      Modules
    </Link>,
    <Link
      key={2}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => clearTabsAndNavigate("/secure/configuration")}
    >
      Configuration
    </Link>,
    <Link
      key={3}
      underline="none"
      sx={{ color: "#000000", cursor: "default", fontSize: "var(--p-size)" }}
    >
      Aircraft
    </Link>,
  ];
  const [filtersOpen, setFiltersOpen] = useState(false);
  const filtersChange = (dropdownFilters, txtFilters) => {
    setFilters({
      dropdowns: dropdownFilters,
      txt: txtFilters,
    });
  };

  const goBackDataObj = {
    icon: "icon-configuration_module_icon",
    color: "#7BB9DB",
    path: "/configuration",
    title: "Configuration",
    isPinned: false,
    componentKey: "Configuration",
    id: 1,
    isModule: true,
    date: generateUUID(),
  };


  const clearState = () => {
    location.state = {};
  };


  return (
    <TypeSeriesConfigurationProvider>
      <PermissionsProvider resourceId={14}>
        <SortingContainer>
          <div className="aircraft-configuration-component">
            <div className="nav-header">
              <NavBarContainer
                goBackData={goBackDataObj}
                dataBreadCrumbs={"/configuration/aircraft"}
                appIcon={"icon-aircraft"}
                moduleIcon={"icon-settings"}
                moduleColor="#7E38C4"
                title={"Aircraft"}
                menuTitle={"Configuration"}
                dataFromManualSearch={dataFromManualSearch}
                moduleId={1}
                isLocalSearch
                clearState={clearState}
                screenActions={
                  <>
                    <AddButtonContainer />
                  </>
                }
                searchActions={
                  <>
                    <FiltersManager
                      onButtonClick={() =>
                        console.warn("Filters button clicked")
                      }
                    />
                    <SortingButton />
                  </>
                }
              />
              {/* <button
              // onClick={() => setFiltersOpen((prev) => !prev)}
              className="filter-toggle"
            >
              <h2>Filters</h2>
              <i className={`icon-arrow-down ${filtersOpen ? "open" : ""}`}></i>
            </button> */}
            </div>
            <div className="aircraft-configuration-component-content">
              <div className="content-header">
                <FilterContainer
                  filtersOpen={filtersOpen}
                  setFiltersOpen={setFiltersOpen}
                />
                {/* <div className="aircraft-header">
                <span className="left-container">
                  <i className="icon-aircraft"></i>
                  <b>Type/Series Addition Line</b>
                  <div className="search-bar-input" style={{ width: "100%" }}>
                    <SearchBarContainer />
                    <i className="icon-search"></i>
                  </div>
                  <AddButtonContainer />
                </span>
              </div> */}
              </div>
              <DropdownsProvider>
                <TypeSeriesList />
              </DropdownsProvider>
            </div>
            <div className="paginator-container"></div>
          </div>
        </SortingContainer>
      </PermissionsProvider>
    </TypeSeriesConfigurationProvider>
  );
};

const SortingContainer = ({ children }) => {
  const { setSortingOrder } = useContext(TypeSeriesConfigurationContext);

  return (
    <SortingProvider
      onOrderChange={(e) => setSortingOrder(e)}
      properties={{
        Type: "Type",
        Series: "Series",
        total_childs: "Total Number of Aircraft",
      }}
    >
      {children}
    </SortingProvider>
  );
};

const NavBarContainer = ({ ...props}) => {
  const { setSortingOrder, onSearch, typeSeriesList } = useContext(
    TypeSeriesConfigurationContext
  );

  useEffect(() => {
    if (props.dataFromManualSearch) {
      console.log("Data from manual search:", props.dataFromManualSearch);
      onSearch(props.dataFromManualSearch);
     
    }
  }, [props.dataFromManualSearch]);
  return (
    <NavBar
      searchInputProps={{
        onTextChange: (e) => onSearch(e),
      }}
      displayRecordsCount={true}
      totalRecords={typeSeriesList?.length}
      {...props}
    />
  );
};
